import { EllipsisIcon, SearchIcon, XIcon } from 'lucide-react'

import { RailHeaderRow } from '@/pages/assessment/components/rail-header-row'

import { Button } from '@/components/lemmala-design-system/button/button'
import { DropdownMenu } from '@/components/lemmala-design-system/dropdown/dropdown-menu'
import { Input } from '@/components/lemmala-design-system/input/input'

import { FILTER_OPTIONS } from './consts'
import { ASSESSMENT_COMMENTS_LABELS } from './labels'
import type { CommentFilter } from './types'

type AssessmentCommentsHeaderProps = {
  search: string | null
  onSearchChange: (search: string | null) => void
  filter: CommentFilter
  onFilterChange: (filter: CommentFilter) => void
}

export const AssessmentCommentsHeader = ({
  search,
  onSearchChange,
  filter,
  onFilterChange,
}: AssessmentCommentsHeaderProps) => {
  if (search !== null) {
    return (
      <RailHeaderRow className='pl-6 pr-4'>
        <div className='flex-1'>
          <Input
            autoFocus
            value={search}
            placeholder={ASSESSMENT_COMMENTS_LABELS.search}
            iconLeft={<SearchIcon className='size-4' />}
            onChange={(event) => onSearchChange(event.target.value)}
          />
        </div>
        <Button
          variant='ghost'
          size='icon'
          className='shrink-0'
          aria-label={ASSESSMENT_COMMENTS_LABELS.closeSearch}
          onClick={() => onSearchChange(null)}
        >
          <XIcon className='size-4' />
        </Button>
      </RailHeaderRow>
    )
  }

  return (
    <RailHeaderRow className='pl-6 pr-4'>
      <span className='flex-1 text-main-foreground-primary text-label-default'>
        {ASSESSMENT_COMMENTS_LABELS.title}
      </span>
      <div className='flex items-center gap-2'>
        <Button
          variant='ghost'
          size='icon'
          aria-label={ASSESSMENT_COMMENTS_LABELS.search}
          onClick={() => onSearchChange('')}
        >
          <SearchIcon className='size-4' />
        </Button>
        <DropdownMenu
          variant='secondary'
          triggerAppearance='headless'
          triggerContent={
            <Button variant='ghost' size='icon' aria-label={ASSESSMENT_COMMENTS_LABELS.options}>
              <EllipsisIcon className='size-4' />
            </Button>
          }
          contentClassName='min-w-52 gap-0 rounded-md text-main-foreground-primary text-body-default'
          menuItems={FILTER_OPTIONS.map(([value, content]) => ({
            content,
            selected: filter === value,
            onClick: () => onFilterChange(value),
          }))}
        />
      </div>
    </RailHeaderRow>
  )
}
